module.exports = __webpack_public_path__ + "static/animation-services-circle-109d78cd3dd7ce83c8cefec129176730.png";